import type { CategoryFilterType } from "types"
import type { FilterInputType, FilterItemType } from "../types"

export const getActiveFilterSlugs = (
  query: string | string[] | undefined
): string[] | undefined => {
  if (typeof query !== "string") return undefined
  const set = new Set<string>()
  const filters = decodeURIComponent(query)

  filters.split("&").forEach((item) => {
    const [, values] = item.split("=")

    values?.split(",").forEach((value) => {
      set.add(value)
    })
  })
  if (set.size === 0) return undefined
  return Array.from(set)
}

export const getActiveFilters = (
  filtersQuery: string | string[] | undefined,
  categoryFilters: CategoryFilterType | null | undefined
): FilterInputType[] | null => {
  if (!filtersQuery || typeof filtersQuery !== "string" || !categoryFilters)
    return null

  const filters = decodeURIComponent(filtersQuery)
  const set = new Set<FilterInputType>()

  filters.split("&").forEach((item) => {
    const [key, values] = item.split("=")
    const categoryItem = categoryFilters.items?.find(
      (catItem) => catItem?.slug === key
    )
    if (!categoryItem) return

    values.split(",").forEach((value) => {
      const subItem = categoryItem.subItems?.find(
        (catSubItem) => catSubItem?.slug === value
      )
      if (!subItem) return

      const newItem = { label: subItem.label ?? "", slug: value }
      if (
        typeof categoryFilters.slug === "string" &&
        typeof categoryItem.slug === "string"
      ) {
        set.add({
          ...newItem,
          category: categoryFilters.slug,
          subCategory: categoryItem.slug,
        })
      }
    })
  })
  if (set.size === 0) return null
  return Array.from(set)
}

export const buildQuery = (
  state: FilterInputType[],
  availableFilters: FilterItemType
): string => {
  // keep the item order the same as in the availableFilters to avoid page cache issues
  const filters = availableFilters.items.reduce((acc, item) => {
    const subCategoryItems = state.filter(
      (stateItem) => stateItem.subCategory === item.slug
    )

    if (subCategoryItems.length) {
      acc[item.slug] = []
      item.subItems?.forEach((subItem) => {
        if (
          subCategoryItems.find(
            (subCategoryItem) => subCategoryItem.slug === subItem.slug
          )
        ) {
          acc[item.slug].push(subItem.slug)
        }
      })
    }
    return acc
  }, {} as Record<string, string[]>)

  const queryString = Object.entries(filters)
    .map(([key, values]) => {
      const combinedValues = values.join(",")
      return `${key}=${combinedValues}`
    })
    .join("&")
  return queryString
}
